import moment from 'moment-timezone'
import { DATE_FORMAT, DATE_FORMAT_US, DATE_TIME_FORMAT, DATE_TIME_FORMAT_US } from '../mixins'

export default {
  install (Vue) {
    /**
     * Show a date in a pretty format.
     *
     * @return string
     */
    Vue.filter('date', (value, formatPreference = null) => {
      if (!value) {
        return null
      }
      let date = moment(value)

      if (!date.isValid()) {
        return
      }

      if (formatPreference === 'month-first') {
        return date.format(DATE_FORMAT_US)
      }

      return date.format(DATE_FORMAT)
    })

    /**
     * Show an array of dates in a pretty format.
     *
     * @return string
     */
    Vue.filter('implodeDates', (value, formatPreference = null) => {
      let format = DATE_FORMAT
      if (formatPreference === 'month-first') {
        format = DATE_FORMAT_US
      }
      let dates = Array.isArray(value) ? value : [value]
      return dates.map(date => moment(date).format(format)).join(', ')
    })

    /**
     * Show a time in a pretty format.
     *
     * @return string
     */
    Vue.filter('time', (value) => {
      let time = moment(value, 'HH:mm:ss')

      if (!time.isValid()) {
        return
      }

      return time.format('hh:mm a')
    })

    Vue.filter('timeTimezone', (value, timezone) => {
      let time = moment.utc(value, 'YYYY-MM-DD HH:mm:ss').tz(timezone)

      if (!time.isValid()) {
        return
      }

      return time.format('hh:mm a')
    })

    /**
     * Show the time until a date/time.
     *
     * If the date has passed will show expired.
     *
     * @return string
     */
    Vue.filter('timeUntil', (value, { timezone = 'UTC', suffix = null, expired = 'Expired' }) => {
      let from = moment.tz(timezone)
      let to = moment.tz(value, 'YYYY-MM-DD HH:mm:ss', timezone)

      if (!to.isValid()) {
        return
      }

      if (to.diff(from) < 0) {
        return expired
      }

      return `${from.to(to, true)} left ${suffix}`.trim()
    })

    /**
     * Show the timezone abbreviation for a given value. If a date is given it'll take into
     * account whether or not that date falls within DST for that timezone.
     *
     * @return string
     */
    Vue.filter('dateTimezone', (value, timezone, formatPreference = null, fromUtc = false, withTime = false) => {
      let format = withTime ? DATE_TIME_FORMAT : DATE_FORMAT
      if (formatPreference === 'month-first') {
        format = withTime ? DATE_TIME_FORMAT_US : DATE_FORMAT_US
      }

      const date = fromUtc ? moment.utc(value).tz(timezone) : moment.tz(value, timezone)

      if (!date.isValid()) {
        return
      }

      return date.format(format + ' (z)')
    })
  }
}
